import { Cloudinary } from "@cloudinary/url-gen";
import { useMemo } from "react";

export default function useCloudinary() {
  return useMemo(
    () =>
      new Cloudinary({
        cloud: {
          cloudName: process.env.CLOUDINARY_CLOUD_NAME,
        },
        url: {
          analytics: false,
        },
      }),
    []
  );
}
